import { defineComponent as _defineComponent } from 'vue'
import { library } from '@fortawesome/fontawesome-svg-core';
import { faChevronRight } from '@fortawesome/pro-solid-svg-icons';
import { ref, watch } from 'vue';

import Badge from '@/fields/components/Badge.vue';
import ButtonLink from '@/shared/components/buttons/ButtonLink.vue';
import { FilterByColumnKey } from '@/shared/handsontable/rework/features/filter/types';

interface Props {
  allFilters: string[];
  activeFilters: string[];
  emptyFilterLabel: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SidebarFilterBadgesContainer',
  props: {
    allFilters: { default: () => [] },
    activeFilters: { default: () => [] },
    emptyFilterLabel: { default: '(empty)' }
  },
  emits: ["update:filter"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update:filter', filter: FilterByColumnKey | null): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { allFilters: string[], activeFilters: string[], emptyFilterLabel: string }

library.add(faChevronRight);

/* -- Props -- */



/* -- State -- */

const activeFilters = ref<string[]>([]);
const additionalVisible = ref<boolean>(false);

/* -- Watchers -- */

watch<string[]>(
  () => props.activeFilters,
  () => {
    if (!props.activeFilters || props.activeFilters.length === props.allFilters.length) {
      activeFilters.value = [];
    } else {
      activeFilters.value = props.activeFilters;
    }
  },
);

/* -- Emits -- */



/* -- Methods -- */

function toggleFilter(filterName: string): void {
  if (activeFilters.value.includes(filterName)) {
    activeFilters.value = activeFilters.value.filter((f: string) => f !== filterName);
  } else {
    activeFilters.value.push(filterName);
  }

  if (!activeFilters.value.length) {
    emit('update:filter', null);
    return;
  }
  emit('update:filter', { type: 'contains', value: '', selectedValues: activeFilters.value });
}

return { __sfc: true,props, activeFilters, additionalVisible, emit, toggleFilter, Badge, ButtonLink }
}

})